import { makeStyles } from '@material-ui/core/styles';

import { draftModalActionButton } from '../policy-drafting.styles';

export default makeStyles((theme) => ({
  dialog: {
    width: 580
  },
  icon: {
    width: 40,
    height: 34,
    alignSelf: 'flex-start'
  },
  title: {
    marginTop: theme.spacing(4)
  },
  body: {
    display: 'block',
    marginTop: theme.spacing(4),
    color: theme.colorPalette.green_90
  },
  details: {
    marginTop: theme.spacing(6)
  },
  detailsTitle: {
    marginBottom: theme.spacing(2),
    color: theme.colorPalette.green_90
  },
  detailsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 0),
    borderTop: `1px solid ${theme.colorPalette.beige_60}`,
    color: theme.colorPalette.green_80
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4)
  },
  actionButton: draftModalActionButton(theme)
}));
